import React, { useState, useEffect } from "react";

import { about } from "../utils/routes";
import { Rings } from "react-loader-spinner";
import img from "../assets/img/slider1.svg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import khaber from "../assets/img/Illustration3.svg";
import mosqe from "../assets/img/mosqe.svg";
import playstore from "../assets/img/playstore.svg";
import Mission from "../assets/img/Mission Target illustration.svg";
import systems from "../assets/img/systems logo.png";
import arrow from "../assets/img/arrow.svg";
import parse from "html-react-parser";
import { ComingSoon } from "../components/dialogs/ComingSoon";

function Aboutus() {
  const leaderTeamSliderSettings = {
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    dots: true,
    speed: 600,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    pauseOnDotsHover: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          settings: "unslick",
        },
      },
      {
        breakpoint: 1000,
        settings: {
          arrows: false,
          infinite: true,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1480,
        settings: {
          arrows: false,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1680,
        settings: "unslick",
      },
    ],
  };
  const bodSliderSettings = {
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    dots: true,
    speed: 600,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    pauseOnDotsHover: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          arrows: false,
          infinite: true,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1440,
        settings: {
          arrows: false,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const settings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 600,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnDotsHover: true,
  };
  const [aboutData, setAboutData] = useState({
    about_discription: "",
    about_us: "",
    board_and_directors: "",
    board_and_directors_cards: "",
    board_and_directors_description: "",
    download_onezapp_app: "",
    download_onezapp_app_url: "",
    leadership_team: "",
    leadership_team_cards: "",
    leadership_team_description: "",
    our_belief_and_imapct_cards: "",
    our_belief_and_impact: "",
    our_investors: "",
    our_investors_cards: "",
    our_investors_description: "",
  });
  const [belief, setBelief] = useState({});
  const [investor, setlnvestor] = useState({});
  const [bordDirector, setBordDirector] = useState({});
  const [leadership, setLeadership] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    var object = {
      id: 2,
    };
    const getUserRequestDTO = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(object),
    };

    fetch(about, getUserRequestDTO)
      .then((res) => res.json())
      .then((result) => {
        setLoading(false);

        setAboutData(result.msg);

        var impectCard = JSON.parse(result.msg.our_belief_and_imapct_cards);
        setBelief({ impectCard });
        var investorCard = JSON.parse(result.msg.our_investors_cards);
        setlnvestor({ investorCard });
        var boardCard = JSON.parse(result.msg.board_and_directors_cards);
        setBordDirector({ boardCard });
        var leadershipCard = JSON.parse(result.msg.leadership_team_cards);
        setLeadership({ leadershipCard });
      });
  }, []);
  return (
    <div style={{ overflow: "hidden" }}>
      <center>
        <div className={loading === true ? "overlay" : " "}>
          <p id="loading">
            {loading ? (
              <Rings color="#91298c" height={160} width={160} />
            ) : null}
          </p>
        </div>
        {/* first  */}
      </center>
      <section className="section about-us">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-12 col-md-6 pt-4">
              <div className="section-title">
                <h1>{parse(aboutData.about_us)}</h1>
                <p className="p-justify">{aboutData.about_discription}</p>
                <a
                  className="btn btn-home-download-zapp "
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.epSystems.oneZap.android.app"
                >
                  {aboutData.download_onezapp_app}
                  <img className="about__playbutton" src={playstore}></img>
                </a>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 about__img order-first order-md-last">
              <Slider {...settings}>
                <div>
                  <img className="about__slider__img" src={img}></img>
                </div>

                <div>
                  <img className="about__slider__img" src={mosqe}></img>
                </div>

                <div>
                  <img className="about__slider__img" src={khaber}></img>
                </div>

                {/* <div>
                    <img className="about__slider__img" src={khaber}></img>
                  </div> */}
              </Slider>
            </div>
          </div>
        </div>
      </section>

      <section className="section our-belief">
        <div className="container">
          <div className="section-title mb-4">
            <h1>{parse(aboutData.our_belief_and_impact)}</h1>
          </div>
          <div className="card">
            <div className="row">
              <div className="col-sm-12 col-md-5">
                {belief?.impectCard?.map((impect, index) => {
                  return (
                    <div className="text-block" key={index}>
                      <h5>{impect.heading}</h5>
                      <p>{impect.desc}</p>
                    </div>
                  );
                })}
              </div>
              <div className="col-sm-12 col-md-6 offset-lg-1 order-first order-md-last">
                <center className="img-wrap">
                  <img src={Mission}></img>
                </center>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section team-member-cards">
        <div className="container">
          <div className="section-title mb-5">
            <h1>{parse(aboutData.board_and_directors)}</h1>
            {/* <p>{aboutData.board_and_directors_description}</p> */}
          </div>
          <div className="row">
            <div className="col-12 mx-auto">
              <Slider {...bodSliderSettings}>
                {bordDirector?.boardCard?.map((boardDir, index) => {
                  return (
                    <a
                      className="team-member-card"
                      href={boardDir.linurl}
                      target="_blank"
                      key={index}
                    >
                      <div className="member-img">
                        <img src={require(`../assets/img/${boardDir.img}`)} />
                      </div>
                      <p>{boardDir.name}</p>
                      <h5>{boardDir.designation}</h5>
                    </a>
                  );
                })}
              </Slider>
            </div>
          </div>
        </div>
      </section>

      <section className="section team-member-cards">
        <div className="container">
          <div className="section-title mb-lg-0 mb-8">
            <h1>{parse(aboutData.leadership_team)}</h1>
            {/* <p>{aboutData.leadership_team_description}</p> */}
          </div>
          <div className="row">
            <div className="col-xl-10 col-md-12 mx-auto d-lg-block d-none">
              <div className="row justify-content-center">
                {leadership?.leadershipCard?.map((leadership, index) => {
                  return (
                    <div className="col-lg-4 mt-lg-5">
                      <a
                        className="team-member-card w-100"
                        href={leadership.linurl}
                        target="_blank"
                        key={index}
                      >
                        {/* <div className="team-bg-img">
                    <img src={CardDirector}></img>
                  </div> */}
                        <div className="member-img">
                          <img
                            src={require(`../assets/img/${leadership.img}`)}
                          />
                        </div>

                        <p>{leadership.name}</p>
                        <h5>{leadership.designation}</h5>
                      </a>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="d-lg-none d-block">
              <Slider {...leaderTeamSliderSettings}>
                {leadership?.leadershipCard?.map((leadership, index) => {
                  return (
                    <a
                      className="team-member-card w-100"
                      href={leadership.linurl}
                      target="_blank"
                      key={index}
                    >
                      {/* <div className="team-bg-img">
                    <img src={CardDirector}></img>
                  </div> */}
                      <div className="member-img">
                        <img src={require(`../assets/img/${leadership.img}`)} />
                      </div>

                      <p>{leadership.name}</p>
                      <h5>{leadership.designation}</h5>
                    </a>
                  );
                })}
              </Slider>
            </div>
          </div>
        </div>
      </section>

      <section className="about__section- five web">
        <div className="container">
          <div className="row about">
            <h1>{parse(aboutData.our_investors)}</h1>
            <p className="about__discription">
              {aboutData.our_investors_description}
            </p>
          </div>
          <div className="row ">
            {investor?.investorCard?.map((investor, index) => {
              return (
                <div className="col-6">
                  <div className="about__investor-card">
                    <div className="about__sysimg">
                      <img
                        target="_blank"
                        className="img-fluid"
                        src={require(`../assets/img/${investor.img}`)}
                      />
                    </div>

                    <div className="about__system-parenthr">
                      {" "}
                      <div className="about__system-hr"></div>
                    </div>
                    <div className="center">
                      <p className="about-p">
                        {investor.discription}...
                        <a
                          target="_blank"
                          className="about__readmore"
                          href={investor.readmoreurl}
                        >
                          Read more
                        </a>
                      </p>
                      <center>
                        <a
                          target="_blank"
                          className="about__syslink"
                          href={investor.sysurl}
                          style={{ color: "white" }}
                        >
                          {investor.syprintsurl}
                        </a>
                        <span>
                          <a
                            target="_blank"
                            href={investor.sysurl}
                            className="about__arrow"
                          >
                            <img
                              className="img-fluid"
                              style={{ width: "60%" }}
                              src={arrow}
                            ></img>
                          </a>
                        </span>
                      </center>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* mobile */}
      <section className="about__section- five mobile">
        <div className="container">
          <div className="row about">
            <h1>{parse(aboutData.our_investors)}</h1>
            <p className="about__discription">
              {aboutData.our_investors_description}
            </p>
          </div>
          <div className="row ">
            {investor?.investorCard?.map((investor, index) => {
              return (
                <div className="col-sm-12">
                  <div className="about__investor-card">
                    <div className="about__sysimg">
                      <img
                        className="img-fluid"
                        src={require(`../assets/img/${investor.img}`)}
                      />
                    </div>

                    <div className="about__system-parenthr">
                      {" "}
                      <div className="about__system-hr"></div>
                    </div>
                    <div className="center">
                      <p className="about-p">
                        {investor.discription}...
                        <a
                          target="_blank"
                          className="about__readmore"
                          href={investor.readmoreurl}
                        >
                          Read more
                        </a>
                      </p>
                      <center>
                        <a
                          className="about__syslink"
                          href={investor.sysurl}
                          style={{ color: "white" }}
                        >
                          {investor.syprintsurl}
                        </a>
                        <span>
                          <a href={investor.sysurl} className="about__arrow">
                            <img
                              className="img-fluid"
                              style={{ width: "60%" }}
                              src={arrow}
                            ></img>
                          </a>
                        </span>
                      </center>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
export default Aboutus;
